import React from 'react'
export const AppSettingsContext = React.createContext({});
export const AppSettingsProvider = AppSettingsContext.Provider;
export const AppSettingsConsumer = AppSettingsContext.Consumer;

